import { QUICK_SEARCH_MAX_LENGTH_LIMITATION } from 'enums/quicksearch'

export function formatSearchPhrase(searchPhrase) {
  return (searchPhrase || '').slice(0, QUICK_SEARCH_MAX_LENGTH_LIMITATION)
}
